import script from "./PointsDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PointsDetail.vue?vue&type=script&setup=true&lang=js"

import "./PointsDetail.vue?vue&type=style&index=0&id=9ebfa51e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ebfa51e"]])

export default __exports__